import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const signup = createAsyncThunk('/auth/signup', async (data) => {
    const response = await api.post('/auth/signup', data);
    return response.data
})

export const signin = createAsyncThunk('auth/signin', async (credentials)=>{
    const response = await api.post('/auth/signin',{
        email: credentials.email,
        password: credentials.password
    })
    console.log(response);
    
    return response.data;

});

export const verifyOtp = createAsyncThunk('/auth/verify-otp', async (data) =>{  
    const response = await api.post('/auth/verify-otp', data);
    return response.data;
   
});

export const googleSignin = createAsyncThunk('/auth/google', async (params) => {
    const response = await api.get('/auth/google/signup', {
        params: params
    })
    return response.data
})

export const verifyEmail = createAsyncThunk('/auth/verifyEmail', async ({token, id})=>{
    const response = await api.get(`/auth/verify-email/${id}/token/${token}`)
    return response.data;
})

export const forgetPassword = createAsyncThunk('/auth/forgetPassword', async (data) =>{
    const response = await api.post('/auth/forgot-password', data)
    return response.data;
})

export const verifyPasswordForgot = createAsyncThunk("/auth/verify-password-forgot", async ({id, token}) =>{
    const response = await api.get(`/auth/verify-forgot/${id}/${token}`)
    return response.data
})

export const changePassword = createAsyncThunk("/auth/reset-password", async ({token, id, data}) => {
    const response = await api.post(`/auth/change-password/${id}/${token}`, data)
    return response.data
});

export const getUserProfile = createAsyncThunk('/auth/get-user-profile', async () => {
    const response = await api.get('/user/profile');
    console.log(response.data)
    return response.data
})

export const updateUserProfile = createAsyncThunk('/auth/update-user-profile', async (data) => {
    const response = await api.post('/user/profile', data);
    return response.data
})